export type BtlCaseSearchColumnKey =
  | 'referenceNumber'
  | 'owner'
  | 'borrowerType'
  | 'status'
  | 'purpose'
  | 'firmName'
  | 'applicantNames'
  | 'financingAmount'
  | 'isTopSlicing'
  | 'productCategory'
  | 'channel'
  | 'submittedAt'
  | 'createdAt'
  | 'updatedAt';

export interface BtlCaseSearchRow {
  id: string;
  referenceNumber: string;
  owner?: string;
  borrowerType?: string;
  status: string;
  purpose: string;
  firmName?: string;
  applicantNames: string;
  financingAmount: number;
  isTopSlicing: boolean;
  productCategory?: string;
  channel?: string;
  submittedAt: Date | null;
  createdAt: Date | null;
  updatedAt: Date | null;
}

const INTERNAL_COLUMNS: BtlCaseSearchColumnKey[] = [
  'referenceNumber',
  'owner',
  'borrowerType',
  'status',
  'purpose',
  'firmName',
  'applicantNames',
  'financingAmount',
  'isTopSlicing',
  'productCategory',
  'channel',
  'submittedAt',
  'createdAt',
  'updatedAt',
];

const EXTERNAL_COLUMNS: BtlCaseSearchColumnKey[] = [
  'referenceNumber',
  'borrowerType',
  'status',
  'purpose',
  'applicantNames',
  'financingAmount',
  'isTopSlicing',
  'submittedAt',
  'createdAt',
  'updatedAt',
];

export function getBtlCaseSearchColumns(isInternalUser: boolean): BtlCaseSearchColumnKey[] {
  return isInternalUser ? INTERNAL_COLUMNS : EXTERNAL_COLUMNS;
}
